import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';
import L from 'leaflet';
import stopPlaceIconUrl from '../icons/ic_place_geofence.svg';

const icon = css`
  cursor: pointer;
  display: flex;
  align-items: center;
  filter: drop-shadow(0px 4px 4px ${colors.gray[11]});

  & > .icon-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & > .icon-container > img {
    width: 32px;
    height: 32px;
  }

  & > .icon-container > span {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    font-weight: bold;
    color: ${colors.black};
    z-index: 1;
  }

  & > p {
    font-size: 12px;
    background-color: white;
    padding: 2px 6px;
    margin-left: -12px;
    font-weight: 500;
    border-radius: 12px;
    padding-left: 12px;
    color: ${colors.black};
  }
`;

const StopIconClusterIcon = (cluster: any) => {
  const numberSpan = `<span>${cluster.getChildCount()}</span>`;
  const placeImage = `<img src="${stopPlaceIconUrl}" />`;

  return new L.DivIcon({
    html: `<div class="${icon}">
        <div class="icon-container">${placeImage}${numberSpan}</div>
        <p>Paradas</p>
    </div>`,
    iconSize: [80, 33],
    iconAnchor: [13.5, 33],
  });
};

export { StopIconClusterIcon };
